import axios from "axios";
import Logger from "../services/logger.js";
import SERVICE_URL, {
    FILE_NAME,
    LOG_TYPE,
    HTTP_CODES
} from "../config/API_DATA";
import Router, { navigate } from "../router/index";
import store from "../store";
import main from "./../main";
import base from "./../config/base";
import { PATHNAME, COMPONENT_NAME, LOCAL_STORAGE_KEYS } from "../util/constants.js";
import { addClassToBody, removeClassBody } from "../util/util";
import { getLogCountFromLocal, setLogCountToLocal, getMultipleErrFromLocal, setMultipleErrToLocal, clearLogCountFromLocal, clearMulErrFromLocal, getAgtLoginResFromLocal, getSysLoginResFromLocal } from './../applocalstorage/localStorage'
import BaseConfiguration from "./../config/base";
import { Event } from "../main.js"
import { httpClient } from "./httpClient.js"
import HttpUI from "./httpUI.js"
/*var AppHttpUI;
if(BaseConfiguration.isMobile) {
    getHttpUIMbl();
      }

export function getHttpUIMbl() {
    try {
      if(BaseConfiguration.isDebug) console.log("getHttpUIMbl");
      AppHttpUI = require("../mobile/http/aHttpUI").default;

    } catch (err) {
            let body = Logger.buildRequest(
              FILE_NAME.HTTP_POST,
              "error in getHttpUIMbl",
              err.toString(),
              "getHttpUIMbl",
              LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
          }
     
    }*/
export default class HttpPost {

    

    static logCount = 0;
    static preventMultipleLog(pError) {
        let returnValue;
        try {
            if (base.isDebug) console.log("preventMultipleLog")


            let localLogCount = getLogCountFromLocal()
            if (localLogCount != null) {
                this.logCount = parseInt(
                    localLogCount
                );
                this.logCount++;
            } else {
                this.logCount = 0;
            }

            setLogCountToLocal(this.logCount);
            if (this.logCount >= 3) {
                returnValue = true;
                let multipleError = Logger.buildRequest(
                    FILE_NAME.HTTPOST,
                    "Error Occurred Multiple Times",
                    pError.toString(),
                    "preventMultipleLog",
                    LOG_TYPE.ERROR
                );
                setMultipleErrToLocal(JSON.stringify(multipleError))
                if (Router.currentRoute.path != PATHNAME.PAGE_500) {
                    navigate(PATHNAME.PAGE_500)
                }
            }
        } catch (err) {
            if (Router.currentRoute.path != PATHNAME.PAGE_500) {
                navigate(PATHNAME.PAGE_500)

            }
        }

        return returnValue;
    }

    static async makeHttpPostRequest(pUrl, pRequestBody) {
        let returnValue = null;

        try {
            let pHeader;

            let langCode = store.getters["language/GET_LANGUAGE"];


            // throw JSON.stringify(pRequestBody)
            if (
                pUrl == SERVICE_URL.GET_SIGNIN_STATUS ||
                pUrl == SERVICE_URL.CREATE_AGENT ||
                pUrl == SERVICE_URL.GET_CAPTCHA ||
                pUrl == SERVICE_URL.GET_COUNTRY_LIST ||
                pUrl == SERVICE_URL.GET_ADMIN_SIGNIN_STATUS
                //  || pUrl == SERVICE_URL.GET_ALL_AGENT
            )
                pHeader = {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "Accept-Language": langCode
                };
            //services without session
            else {
                let jwtToken = null;
                let agtLogToken = getAgtLoginResFromLocal();
                let sysLogToken = getSysLoginResFromLocal();
                // let token = agtLogToken ? agtLogToken : sysLogToken ? sysLogToken : null;
                let token = agtLogToken ? agtLogToken : (sysLogToken ? sysLogToken : null);
                if (token) {
                    jwtToken = JSON.parse(token);
                    jwtToken =
                        (jwtToken && jwtToken.authorization) ? jwtToken.authorization : null;
                } else {
                    // if (store && store.state) {
                    //     if (store.state.sAgtLogin && store.state.sAgtLogin.signInRes && store.state.sAgtLogin.signInRes.authorization) {
                    //         jwtToken = store.state.sAgtLogin.signInRes;
                    //         if (base.isDebug) console.log("from Agent login");
                    //     } else if (store.state.sSysLogin && store.state.sSysLogin.AdminSignInRes && store.state.sSysLogin.AdminSignInRes.authorization) {
                    //         jwtToken = store.state.sSysLogin.AdminSignInRes;
                    //         if (base.isDebug) console.log("from System login");
                    //     }
                    //     jwtToken =
                    //         (jwtToken && jwtToken.authorization) ? jwtToken.authorization : null;
                    // }
                }

                /*if (store && store.getters) {
                    if (store.getters["sAgtLogin/GET_SIGNIN_RES"]) {
                        jwtToken = store.getters["sAgtLogin/GET_SIGNIN_RES"];
                        console.log("from Agent login");
                    } else if (store.getters["sSysLogin/GET_ADMIN_SIGNIN_RES"]) {
                        jwtToken = store.getters["sSysLogin/GET_ADMIN_SIGNIN_RES"];
                        console.log("from System login");
                    }
                    jwtToken =
                        jwtToken && jwtToken.authorization ? jwtToken.authorization : null;
                }*/

                /*if (jwtToken && typeof jwtToken === 'object')
                    jwtToken = JSON.stringify(jwtToken);*/

                pHeader = {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: jwtToken,
                    "Accept-Language": langCode
                }; //services with session
            }

            httpClient.defaults.headers = pHeader;
            // let httpClient = axios.create({
            //    
            
            //     timeout: base.timeout,
            //     headers: pHeader
            // });
            if(BaseConfiguration.isMobile) {                
                var AppHttpUI = require("../mobile/http/aHttpUI").default;
                AppHttpUI.UIprocess();
            }
            else{
                HttpUI.UIprocess();
            }
            // let loader=null;
            
            ///  httpClient.defaults.timeout = (1000 * 20); // timeout:20 seconds
    //         httpClient.interceptors.request.use(config => {
    //             // for every request start the progress
    //             if(!BaseConfiguration.isMobile) {
    //                 if (main) main.$Progress.start();
    //             }else{ 
    //                 Event.$emit("progrsBarBool", true);
    //             }
    //             // if (config.url == SERVICE_URL.GET_SEARCH_RESULT) {
    //             //     addClassToBody(COMPONENT_NAME.FLIGHTRESULTS+  ' Loading');
    //             // }else 
    //             if (config.url == SERVICE_URL.GET_PRICING_SEARCH) {
    //                 
    //                 if(BaseConfiguration.isMobile){
    //                     setTimeout(async () => {
    //                         loader = await main.$ionic.loadingController.create({
    //                           message: "Please wait..."
    //                         });
    //                         loader.present();                            
    //                       },);
    //                     }
    //                     else{
    //                         addClassToBody(COMPONENT_NAME.FLIGHTRESULTS + ' Loading');
    //                     }
    //             } else if (config.url == SERVICE_URL.CREATE_BOOKING) {
    //                 addClassToBody(COMPONENT_NAME.PAYMENTPAGE + ' Loading');
    //             }else if (config.url == SERVICE_URL.API_CREATE_PAYMENT_FOR_TICKETING) {
    //                 addClassToBody(COMPONENT_NAME.TICKET_NOW + ' Loading');
    //             }else if(config.url==SERVICE_URL.UPDATE_PRICING||config.url==SERVICE_URL.CREATE_PRICING){
    //                 addClassToBody(COMPONENT_NAME.CREATE_PRICING + ' Loading');
    //             }
    //             return config;
    //         });

    //     httpClient.interceptors.response.use(response => {
    //             //  finish when a response is received
    //             if(!BaseConfiguration.isMobile) {
    //                 if (main) main.$Progress.finish(); 
    //             }else {
    //             Event.$emit("progrsBarBool", false);
    //             }
    //             if(loader!=null) {
    //             loader.dismiss();
    //             }
    //             
    //             // if (response.config.url == SERVICE_URL.GET_SEARCH_RESULT){
    //             //     addClassToBody(COMPONENT_NAME.FLIGHTRESULTS);
    //             // }
    //             return response;
    //    });



            //to check  network connection
            if (navigator.onLine) {
                returnValue = await httpClient
                    .post(pUrl, pRequestBody)
                    .then(response => {
                        return response;
                    })
                    .catch(error => {
                        if (this.preventMultipleLog(error)) return null;
                        else if (pUrl != SERVICE_URL.LOGGER_URL) {
                            // Router.push("pError");
                            let err= {
                                service: pUrl,
                                error:  error.toString()
                            }
                            let body = Logger.buildRequest(
                                FILE_NAME.HTTPOST,
                                "error in making post request",
                                JSON.stringify(err),
                                "makeHttpPostRequest",
                                LOG_TYPE.ERROR
                            );
                            Logger.getResponse(body);
                        }
                    });
            } else {
                throw HTTP_CODES.ERROR_NET;
            }
        } catch (err) {
            // Router.push("pError");
            if (err == HTTP_CODES.ERROR_NET || !navigator.onLine) {
                if (Router.currentRoute.path != PATHNAME.PAGE_404) {


                    navigate(PATHNAME.PAGE_404)
                }
            } else {
                if (this.preventMultipleLog(err)) {
                    return null;
                } else {

                    let error= {
                        service: pUrl,
                        error:  err.toString()
                    }
                    let body = Logger.buildRequest(
                        FILE_NAME.HTTPOST,
                        "httppost failed",
                        JSON.stringify(error),
                        "makeHttpPostRequest",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            }
        } finally {
            if (returnValue && returnValue.status == HTTP_CODES.SUCCESS) {
                this.logCount = 0;
                clearLogCountFromLocal();
                let multipleError = getMultipleErrFromLocal()
                if (multipleError) {
                    Logger.getResponse(JSON.parse(multipleError));

                    clearMulErrFromLocal()

                }
            }
            // if (store.getters["sSimulateJwt/GET_IS_SIMULATE_JWT"] && base.isDebug) {

            //     returnValue = {
            //         data: JSON.parse(
            //             '{"status":"Error","errorcode":"jwt","error":["Token is not valid/expired","jwt malformed"]}'
            //         )
            //     };
            // }
        }
        return returnValue;
    }

  
/*
    static async cancelHttpPostRequest(pUrl, pRequestBody) {
        let pHeader;

        let langCode = store.getters["language/GET_LANGUAGE"];


        //throw JSON.stringify(pRequestBody)
        if (
            pUrl == SERVICE_URL.GET_SIGNIN_STATUS ||
            pUrl == SERVICE_URL.CREATE_AGENT ||
            pUrl == SERVICE_URL.GET_CAPTCHA ||
            pUrl == SERVICE_URL.GET_COUNTRY_LIST ||
            pUrl == SERVICE_URL.GET_ADMIN_SIGNIN_STATUS
            //  || pUrl == SERVICE_URL.GET_ALL_AGENT
        )
            pHeader = {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Accept-Language": langCode
            };
        //services without session
        else {
            let jwtToken = null;

            if (store && store.state) {
                if (store.state.sAgtLogin && store.state.sAgtLogin.signInRes && store.state.sAgtLogin.signInRes.authorization) {
                    jwtToken = store.state.sAgtLogin.signInRes;
                    if (base.isDebug) console.log("from Agent login");
                } else if (store.state.sSysLogin && store.state.sSysLogin.AdminSignInRes && store.state.sSysLogin.AdminSignInRes.authorization) {
                    jwtToken = store.state.sSysLogin.AdminSignInRes;
                    if (base.isDebug) console.log("from System login");
                }
                jwtToken =
                    (jwtToken && jwtToken.authorization) ? jwtToken.authorization : null;
            }

            // if (store && store.getters) {
            //     if (store.getters["sAgtLogin/GET_SIGNIN_RES"]) {
            //         jwtToken = store.getters["sAgtLogin/GET_SIGNIN_RES"];
            //         console.log("from Agent login");
            //     } else if (store.getters["sSysLogin/GET_ADMIN_SIGNIN_RES"]) {
            //         jwtToken = store.getters["sSysLogin/GET_ADMIN_SIGNIN_RES"];
            //         console.log("from System login");
            //     }
            //     jwtToken =
            //         jwtToken && jwtToken.authorization ? jwtToken.authorization : null;
            // }

            // if (jwtToken && typeof jwtToken === 'object')
            //     jwtToken = JSON.stringify(jwtToken);

            pHeader = {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: jwtToken,
                "Accept-Language": langCode
            }; //services with session
        }

        let httpClient = axios.create({
           
            
            timeout: base.timeout,
            headers: pHeader
        });
        ///  httpClient.defaults.timeout = (1000 * 20); // timeout:20 seconds
        httpClient.interceptors.request.use(config => {
            if (main) main.$Progress.start(); // for every request start the progress
            return config;
        });

        httpClient.interceptors.response.use(response => {
            if (main) main.$Progress.finish(); // finish when a response is received
            return response;
        });


        const CancelToken = axios.CancelToken;
        var cancel;
        // const CancelToken = httpClient.CancelToken;
        // const source = CancelToken.source();



        //if (navigator.onLine) {
        // returnValue = 
        httpClient.post(pUrl, pRequestBody, {
                //cancelToken: source.token
                cancelToken: new CancelToken(function executor(c) {
                    cancel = c;
                })
            })
            .catch(function(thrown) {
                if (axios.isCancel(thrown)) {
                    console.log(thrown.message);
                }
            });

        //source.cancel('Operation canceled by the user.');
        cancel('Operation canceled by the user.');
        // } else {
        //     throw "invalid";
        // }

    }*/
}